import FolderNameModal from '@/components/MantineFileManager/FolderNameModal';
import { useUpdateFileMutation } from '@/features/api/endpoints/fileEndpoints';
import type { DirectusFiles } from '@/models/types';
import { ActionIcon, Tooltip } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconPencil } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type RenameFileBtnProps = {
  file: DirectusFiles;
};

const RenameFileBtn = ({ file }: RenameFileBtnProps) => {
  const { t } = useTranslate();
  const [updateFile] = useUpdateFileMutation();

  const handleRenameFile = () => {
    modals.open({
      title: t('file.rename.title'),
      children: (
        <FolderNameModal
          initialValue={file.title ?? file.filename_download}
          label={t('file.name')}
          submitLabel={t('common.save')}
          onSubmit={async name => {
            try {
              await updateFile({
                body: { title: name },
                id: file.id,
              }).unwrap();
              notifications.show({
                color: 'green',
                message: t('file.rename.success'),
              });
            } catch {
              notifications.show({
                color: 'red',
                message: t('file.rename.error'),
              });
            }
          }}
        />
      ),
    });
  };

  return (
    <Tooltip label={t('file.rename.title')} withArrow>
      <ActionIcon
        variant="subtle"
        color="blue"
        onClick={handleRenameFile}
        aria-label={t('file.rename.title')}
      >
        <IconPencil size={18} />
      </ActionIcon>
    </Tooltip>
  );
};

export default RenameFileBtn;
